import ClickOutside from "vue-click-outside";
import filters from "@/components/Search/filters";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            filters
        };
    },
    props: ["currentFilter", "filterIsOpen"],
    methods: {
        onFilterButtonClick() {
            this.$emit("filter-toggle", !this.filterIsOpen);
        },
        onFilterEntryClick(f) {
            this.$emit("filter-select", f);
            this.$emit("filter-toggle", false);
            this.$parent.$refs.searchInputField.focus();
        },
        onFilterOutsideClick() {
            if (this.filterIsOpen) {
                this.$emit("filter-toggle", false);
            }
        }
    },
    directives: {
        ClickOutside
    },
    computed: {
        ...mapGetters(["currentLanguage"])
    }
};



// WEBPACK FOOTER //
// ./src/components/Search/SearchFilter/SearchFilter.js